import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, throwError } from 'rxjs';
import { header } from 'app/_misc/headers';
import { INotificationGroup } from '../_models/INotificationGroup';

@Injectable({ providedIn: 'root' })
export class NotificationsService {
  constructor(private httpClient: HttpClient) { }
  
  getNotifications(formData: FormData) {
    return this.httpClient.post('/notifications/getnotifications', formData, { 
      headers: new header().FormHeader, observe: 'response' 
    }).pipe(map(response => { 
      return response.body as INotificationGroup[]; 
    }), catchError(this.handleError));
  }

  readNotification(formData: FormData) {
    return this.httpClient.post('/notifications/readnotification', formData, { 
      headers: new header().FormHeader, observe: 'response' 
    }).pipe(map(response => { 
      return response.body; 
    }), catchError(this.handleError));
  }

  deleteNotification(formData: FormData) {
    return this.httpClient.post('/notifications/deletenotification', formData, { 
      headers: new header().FormHeader, observe: 'response' 
    }).pipe(map(response => { 
      return response.body; 
    }), catchError(this.handleError));
  }

  handleError(error: any) { return throwError(error); }
}
